import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67d958cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "image-holder" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "body" }

import { computed, inject } from 'vue'

import { useContent } from '@/composables/content'
import { ModalWrapper, useModal } from '@/composables/general'
import Story from '@/models/Story'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsFeed',
  props: { blok: Object },
  setup(__props) {



const { news } = useContent()
const lastNews = computed(() => news.value.slice(0, 5))

const modalWrapper = inject(ModalWrapper)!
const openModal = (story: typeof Story) => useModal(story, modalWrapper)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lastNews), (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "item",
        onClick: ($event: any) => (openModal(item))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "image",
            src: item.thumb,
            alt: item.title
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(item.title), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(item.perex), 1)
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})